exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.chev-pos {\n    position: relative;\n    top: -3px;\n    left: -3px;\n}\n", ""]);

// exports
